'use client'

import { useEffect } from 'react'

import { Box, cn } from '@podo-app/design-system-temp'

type Props = {
  clickable?: boolean
}

export const Overlay = ({ clickable = true }: Props) => {
  const preventScroll = () => {
    const currentScrollY = window.scrollY
    document.body.style.position = 'fixed'
    document.body.style.width = '100%'
    document.body.style.top = `-${currentScrollY}px` // 현재 스크롤 위치
    document.body.style.overflowY = 'scroll'
    return currentScrollY
  }

  const allowScroll = (prevScrollY: number) => {
    document.body.style.position = ''
    document.body.style.width = ''
    document.body.style.top = ''
    document.body.style.overflowY = ''
    window.scrollTo(0, prevScrollY)
  }

  useEffect(() => {
    const prevScrollY = preventScroll()
    return () => {
      allowScroll(prevScrollY)
    }
  }, [])

  return (
    <Box
      className={cn([
        'mx-auto mobile:min-w-[360px] tablet:max-w-[480px]',
        'fixed inset-0 z-[60] bg-[#1C1C1C]/70',
        clickable ? '' : 'select-none',
      ])}
    />
  )
}
